import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Serviço para registro de logs de erro na aplicação
 */
@Injectable()
export class LogErroService {
  private urlModulo = `${environment.urlAPI}/logerro`;

  constructor(private http: HttpClient) { }

  /**
   * Grava um log de erro com autenticação do usuário
   * @param descricao Descrição do erro
   * @returns Promise com o resultado da operação
   */
  public gravaLog(descricao: string): Promise<any> {
    const payload = {
      descricao: descricao
    };

    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}`, payload)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Grava um log de erro sem necessidade de autenticação do usuário
   * @param descricao Descrição do erro
   * @returns Promise com o resultado da operação
   */
  public gravaLogAuth(descricao: string): Promise<any> {
    const payload = {
      descricao: descricao
    };

    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-auth`, payload)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Grava um log de erro com informações detalhadas
   * @param erro Erro capturado
   * @param componente Nome do componente ou serviço onde ocorreu o erro
   * @param metodo Nome do método onde ocorreu o erro
   * @returns Promise com o resultado da operação
   */
  public gravaLogDetalhado(erro: any, componente: string, metodo: string): Promise<any> {
    const descricao = `
      Componente: ${componente}
      Método: ${metodo}
      Erro: ${JSON.stringify(erro)}
    `;

    return this.gravaLog(descricao);
  }

  /**
   * Grava um log de erro de sistema com detalhes técnicos
   * @param erro Erro capturado
   * @param origem Origem do erro (componente, serviço ou subsistema)
   * @returns Promise com o resultado da operação
   */
  public gravaLogSistema(erro: any, origem: string): Promise<any> {
    let mensagemErro: string;
    
    if (typeof erro === 'string') {
      mensagemErro = erro;
    } else if (erro.message) {
      mensagemErro = erro.message;
    } else {
      mensagemErro = JSON.stringify(erro);
    }

    const payload = {
      descricao: mensagemErro,
      origem: origem,
      data: new Date().toISOString(),
      detalhes: JSON.stringify(erro)
    };

    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-sistema`, payload)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }
}


// WEBPACK FOOTER //
// /app/src/app/services/logerro.service.ts